import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p className="footer-line">
        Building practical digital solutions for learning, assessment, and business growth. &copy; 2026. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
